<template>
    <div class="flex go-new-page" id="2-9">
        <h3>项目考核</h3>
        <a @click="goTopic">去做题 ></a>
        <!-- 弹出对话框 -->
        <el-drawer
                title="项目考核"
                :visible.sync="drawerTopic"
                :wrapperClosable="false"
                :show-close="true"
                class="drawerTopic"
                :closed="isOpenPop('0')"
                direction="btt">
            <div class="drawerMain-box writeNote-box">
                <Topic/>
<!--                <iframe class="iframe" ref="iframe" src="../assets/topic.html" width="100%" height="100%" frameborder="0"></iframe>-->
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import Topic from './Topic'
    export default {
        name: "extend",
        components: {
            Topic
        },
        data() {
            return {
                dialogVisible: false,
                drawerTopic: false,
            }
        },
        mounted() {
            window.isOpenPop = this.isOpenPop; // 判断是否开启底部弹窗 1、弹框弹出 0、弹框消失
        },
        methods: {
            goTopic() {
                this.drawerTopic = true;
                this.isOpenPop('1');
                this.scrollTop();
            },
            // 判断是否开启底部弹窗,跟移动端交互
            isOpenPop(popTypeNum) {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
                    if (window.webkit) {
                        window.webkit.messageHandlers.jsCallBack.postMessage({
                            type: popTypeNum,
                        });
                    }
                    return 'iOS'; // iOS device
                } else if (userAgent.match(/Android/i)) {
                    window.Android.ebookHtmlToAndroid(popTypeNum);
                    return 'Android'; // Android device
                } else {
                    return 'PC'; // PC device
                }
            },
            scrollTop() {
                setTimeout(function () {
                    var box = document.getElementById('scroll_top');
                    box.scrollTop = 0; // 设置scrollTop为0，滚动到最顶部
                },20)
            }
        }
    }
</script>

<style scoped lang="scss">
.iframe {
    height: 100% !important;
}
.go-new-page {
    h3 {
        font-size: 20px;
    }
    a {
        font-size: 16px;
        width: 100px;
        text-align: right;
        color: #00A8AC;
        cursor: pointer;
    }
}
.go-new-page a:hover {
    opacity: 0.8;
}
.drawerTopic {
    /deep/.el-drawer {
        height: 80% !important;
        .el-drawer__body {
            padding: 0 !important;
            overflow: hidden;
            .drawerMain-box {
                height: 100%;
            }
        }

    }
}
</style>
